import { render, staticRenderFns } from "./InputAnswerText.vue?vue&type=template&id=018bf476&scoped=true&lang=pug&"
import script from "./InputAnswerText.vue?vue&type=script&lang=ts&"
export * from "./InputAnswerText.vue?vue&type=script&lang=ts&"
import style0 from "./InputAnswerText.vue?vue&type=style&index=0&id=018bf476&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018bf476",
  null
  
)

export default component.exports